import React, { Component } from "react";

class HeaderLogo extends Component {
    
    render() {
        return (
            <div id="logo">
                <span className="image avatar48">
                    <img src={this.props.image} alt="" />
                </span>
                <h1 id="title">{this.props.title}</h1>
                <p>{this.props.desig}</p>
            </div>
        );
    }
}

export default HeaderLogo;